import classNames from 'classnames'
import { ReactElement, useContext } from 'react'
import { SchedulingWizardContext } from './SchedulingWizard'

export function AppointmentTypeSelector(): ReactElement {
  const { appointmentTypes, apptType, back, setApptType, patientType } = useContext(SchedulingWizardContext)
  return (
    <div
      className={`flex flex-col gap-y-2 animate-duration-[400ms] ${back ? `animate-fade-right` : `animate-fade-left`}`}
    >
      <span className="text-sm font-medium leading-tight text-default">
        What type of appointment are you looking for?
      </span>
      {appointmentTypes.length > 0 ? (
        <div className="flex grow flex-col gap-y-1.5 overflow-y-auto">
          {appointmentTypes
            .filter((type) => !type.patientType || type.patientType === patientType)
            .map((type) => (
              <button
                key={type.id}
                className={classNames(`rounded-lg px-4 py-2 text-left text-strong shadow-elevation-1`, {
                  'border-2 border-primary-600 bg-primary-alpha-8': apptType === type,
                  'border bg-surface hover:bg-surface-muted': apptType !== type,
                })}
                onClick={() => setApptType(type)}
              >
                <span className="text-sm font-medium leading-[17.5px]">{type.alias ?? type.displayName}</span>
              </button>
            ))}
        </div>
      ) : (
        <span className="text-left text-subtle">There are currently no appointment types available</span>
      )}
    </div>
  )
}
